module.exports = "<div style=\"border: 1px solid red\">Delete-Product Component</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/product-components/delete-product/delete-product.component.html
// module id = ./src/app/product-components/delete-product/delete-product.component.html
// module chunks = main